import { render, staticRenderFns } from "./water.vue?vue&type=template&id=57002896&scoped=true"
import script from "./water.vue?vue&type=script&lang=js"
export * from "./water.vue?vue&type=script&lang=js"
import style0 from "./water.vue?vue&type=style&index=0&id=57002896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57002896",
  null
  
)

export default component.exports